/** Header search autocomplete — shared across pages that mount `HomeHeader`. */
export const HEADER_SEARCH_KEYWORD_SUGGESTIONS = [
  '합주실 스토어',
  '합주실',
  '합주공간',
  '합주스튜디오',
  '합정 뮤직 업라운드',
  '합정 뮤직스퀘어',
  '합정 굿마인드',
] as const;
